import {
    createLockedCalendarEventsStore,
    getLockedCalendarEventsReader,
} from 'owa-calendar-events-store';

// We are creating out own locked store since we are not dependent on the surface locked store anymore
// WI: 45077: We have to followup to see if we need to clean up this lock
const calendarEventsLockedStore = createLockedCalendarEventsStore();
const calendarEventsLockedStoreReader = getLockedCalendarEventsReader(
    calendarEventsLockedStore.getLockId()
);

export const fetchFullCalendarEvent = calendarEventsLockedStore.fetchFullCalendarEvent;
export const fetchFullCalendarEventAndUpdateItemResponseShapeType =
    calendarEventsLockedStore.fetchFullCalendarEventAndUpdateItemResponseShapeType;
export const getFullCalendarEvent = calendarEventsLockedStoreReader.getFullCalendarEvent;
